import classNames from 'classnames'
import { Routes } from 'common/routeConfig'
import Footer from 'components/footer/Footer'
import Header from 'components/header/Header'
import React from 'react'
import { useLocation, Outlet } from 'react-router-dom'
import MetaInfo from 'components/metaInfo/MetaInfo'
import Menu from '../menu/Menu'

type Props = {
    children?: any
    selectedSubmenu: string
    setSelectedSubmenu: React.Dispatch<React.SetStateAction<string>>
    setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const AuthWrapper: React.FC<Props> = ({
    children,
    selectedSubmenu,
    setSelectedSubmenu,
    setIsMenuOpen
}) => {
    const { pathname } = useLocation()
    const isDataLoading = false

    const containerNeedsFullWidth = pathname === Routes.BASE

    const onToggleMenu = (open: boolean) => {
        setIsMenuOpen(open)
    }

    return (
        <>
            <Header />
            <div className="main-container">
                <Menu
                    onToggleMenu={onToggleMenu}
                    selectedSubmenu={selectedSubmenu}
                    setSelectedSubmenu={setSelectedSubmenu}
                />
                <main
                    className={classNames(
                        { 'no-scroll': isDataLoading },
                        {
                            'full-width': containerNeedsFullWidth
                        }
                    )}
                >
                    <MetaInfo />
                    {children || <Outlet />}
                </main>
            </div>
            <Footer />
        </>
    )
}

export default AuthWrapper
